module.exports = __webpack_public_path__ + "static/media/FCMH-Raster-01.34bbfa1d.svg";